import { GET_USER } from "../constants/getters";
import { SET_USER } from "../constants/mutations";
export default {
  state: {
    user: null,
  },
  getters: {
    [GET_USER](state){ return state.user }
  },
  actions: {
    
  },
  mutations: {
    [SET_USER](state,value){
      state.user=value ?? null
    },
  },
};